import React from "react";
import Button from "../../../../components/Button";
import Popup from "../../../../components/Popup";
var MenuReminderPopup = function (_a) {
    var isOpen = _a.isOpen, close = _a.close, openMenuPopup = _a.openMenuPopup, submit = _a.submit;
    return (React.createElement(Popup, { open: isOpen, handleClose: close, title: "Willst du ein Spar-Menü dazu?", subtitle: "Spare bis zu 30%", position: "bottom", customStyle: "menu-options", draggable: true },
        React.createElement("div", null),
        React.createElement("img", { src: "".concat("/wp-content/plugins/pottsalat/static/images", "/menu.webp"), alt: "Men\u00FC Optionen", className: "menu-banner" }),
        React.createElement("div", { className: "bottom-close" },
            React.createElement(Button, { onClick: function () {
                    close();
                    submit();
                }, label: "Nein danke" }),
            React.createElement(Button, { onClick: function () {
                    close();
                    openMenuPopup();
                }, label: "Ja, als Men\u00FC bestellen" }))));
};
export default MenuReminderPopup;
